import React from 'react';
import NumberFormat from 'react-number-format';


export default class PreliminarzWniosekBud extends React.Component {
  constructor(props) {
    super(props); 

  }


render() {
const { data, status, stopka, date, wyddoch, text1, czyuwagicheck } = this.props;

return (
<React.Fragment>
  <table class="printable" cellSpacing="0" border="0">
  
  <colgroup width="67"></colgroup>
  
  <colgroup width="90"></colgroup>
  
  <colgroup span="4" width="67"></colgroup>
  
  <colgroup width="100"></colgroup> {/* @*nazwa*@ */}
  
  <colgroup width="136"></colgroup> {/* @*obowiazujacyplan*@ */}
  
  <colgroup width="110"></colgroup> {/* @*zwiekszenia*@ */}
  
  <colgroup width="110"></colgroup> {/* @*zmniejszenia*@ */}
  
  <colgroup width="150"></colgroup> {/* @*plan po*@ */}
  
  <tbody>
  
      <tr>
  
          <td className="td-1" colSpan="2" height="47" align="center" valign="top"><i>Sygnatura</i></td>

          {/* <td className="td-1 " colSpan="8" align="center" valign="middle"><b className="text-nowrap nowrap"><font className="text-nowrap nowrap" size="3" color="#000080">WNIOSEK ZMIAN W BUDŻECIE DLA UCHWAŁY {props.uchwala}</font></b></td> */}
          <td className="td-1" colSpan="8" align="center" valign="middle"><b><font size="3" color="#000080">{data.tytul}<br />na  dzień {date}</font></b></td>
  
          <td className="td-1" align="center"></td>
  
      </tr>
  
      <tr>
  
          <td className="td-2" height="21" align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="right"><b>Adresat:</b></td>
  
          <td className="td-3" colSpan="2" align="center"><div dangerouslySetInnerHTML={ { __html: data.adresat } }></div></td>
  
      </tr>
  
      <tr>
  
          <td className="td-2" height="17" align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          {/* @*<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000" align="left"></td>*@ */}
  
          <td className="td-1 pl-1 pr-1">Wydziały</td>
  
          <td className="td-4 pl-1 pr-1" colSpan="4" align="center">{data.wydzialy}</td>
  
          <td align="left"></td>
  
          {/* @*<td align="left"></td>*@ */}
  
          <td align="left"></td>
  
          <td className="td-3" align="left"></td>
  
      </tr>
  
      <tr>
  
          <td className="td-2" colSpan="2" height="18" align="center" valign="bottom"></td>
  
          <td align="left"></td>
  
          {/* @*<td style=" border-bottom: 1px solid #000000; border-left: 1px solid #000000" align="left"></td>*@ */}
  
          <td className="td-5 pl-1 pr-1">{wyddoch === "D" ? (<p>Dochody</p>) : (<p>Wydatki</p>)}</td>
  
          <td className="td-6 pl-1 pr-1" colSpan="4" align="center">{data.rodzaje}</td>
  
          <td align="left"></td>
  
          {/* @*<td align="left"></td>*@ */}
  
          <td align="left"></td>
  
          <td className="td-3" align="center"></td>
  
      </tr>
  
      <tr>
  
          <td className="td-2" colSpan={status ? '2' : '3'} height="18" align="center" valign="bottom"><i>pieczątka wydziału</i></td>
  
          <td align="left"><i></i></td>
  
          <td align="center"><i></i></td>
  
          <td align="left"><i></i></td>
  
          <td align="left"><i></i></td>
  
          <td align="left"><i></i></td> 
  
          <td align="left"><i></i></td>
  
          <td class="tabela" align="center"><b><i>Plan ubiegłoroczny</i></b></td>
  
          {status ? <td class="tabela" align="center"><b><i>Plan</i></b></td> : null}
  
          <td class="tabela" align="center"><b><i>Wniosek</i></b></td>
  
      </tr>
  
      <tr>
  
          <td class="tabela" colSpan={status ? '8' : '9'} height="21" align="center"><b><font size="3">OGÓŁEM {text1} </font></b></td>
  
          <td class="tabela" align="right"><b><font size="2"><NumberFormat value={data.przed} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></font></b></td>
  
          {status ? <td class="tabela" align="right"><b><font size="2"><NumberFormat value={data.zmniejszenia} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></font></b></td> : null}
  
          <td class="tabela" align="right"><b><font size="2"><NumberFormat value={data.wniosek} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></font></b></td>
  
      </tr>
  
      {data.dane.map(dane => {
  
      const { rozdzial, dzial, sumCol0, sumCol1, sumCol2, sumCol3, groups} = dane;
  
      return (<>
  
      <tr key="a">
  
          <td class="tabela" colSpan={status ? '8' : '9'}><b><font size="3">Dział: {dzial} Rozdział: {rozdzial}</font></b></td>
  
  
  
          <td class="tabela" align="right"><b><NumberFormat value={sumCol0} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></b></td>
  
          {status ? <td class="tabela" align="right"><b><NumberFormat value={sumCol1} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></b></td>: null}
  
          <td class="tabela" align="right"><b><NumberFormat value={sumCol3} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></b></td>
  
      </tr>
  
      {groups.map(dane2 => {
  
      const { nazwaGrupy, sumCol0, sumCol1, sumCol2, sumCol3, dane} = dane2;
  
      return (<>
  
      <tr>
  
      <td class="tabela td-9" colspan={status ? '8' : '9'}><b><font size="3">{nazwaGrupy}</font></b></td>
  
      <td class="tabela" align="right"><b><NumberFormat value={sumCol0} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></b></td>
  
      {status ? <td class="tabela" align="right"><b><NumberFormat value={sumCol1} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></b></td> : null}
  
      <td class="tabela" align="right"><b><NumberFormat value={sumCol3} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></b></td>
  
      </tr>
  
      {dane.map(dane3 => {
  
          const { paragraf, p4, pozycja, nazwa, przed, zmniejszenia, zwiekszenia, wniosek, zadania, uwagi} = dane3;
  
          return (<>
  
          <tr>
  
              <td class="tabela" height="17" align="center"><b>{paragraf}{p4}</b></td>
  
              <td class="tabela" height="17" align="center">{pozycja}</td>
  
              <td class="tabela" colspan={status ? '6' : '7'} align="left" valign="middle">{nazwa}</td>
  
              <td class="tabela" align="right" valign="middle"><NumberFormat value={przed} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
  
              {status ? <td class="tabela" align="right" valign="middle"><NumberFormat value={zwiekszenia} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td> : null}
  
              <td class="tabela" align="right" valign="middle"><NumberFormat value={wniosek} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
  
          </tr>
          {uwagi.length > 0 && czyuwagicheck ? (<tr>
              <td class="tabela" colspan="11"><span className="ml-2">Uwagi: {uwagi}</span> </td>
          </tr>) : null}
  
          {zadania && zadania.length > 0 ? (<>
  
          <tr>
  
              <td className="tabela" colSpan="11">
  
                  <table width="98%" className="m-1">
  
                      <thead>
  
                          <tr>
  
                              <th className="tabela">Nazwa</th>
  
                              <th className="tabela ">Koszt zmian</th>
  
                              <th className="tabela ">Wniosek</th>
  
                          </tr>
  
                      </thead>
  
                      <tbody>
  
                      {zadania.map(danez => {
  
                      const { nazwa, przed, wniosek} = danez;
  
                      return (<tr>
  
                          <td className="tabela"><b>{nazwa}</b></td>
  
                          <td className="tabela"><NumberFormat value={przed} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
  
                          <td className="tabela"><NumberFormat value={wniosek} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
  
                      </tr>) 
  
                      }) }
  
                      </tbody>
  
                  </table>
  
              </td>
  
          </tr>
  
          </>) : null }
  
          </>); }
  
      )}
  
  
  
      </>);}
  
      )}
  
  
  
      </>);}
  
      )} 
  
  
  
     
  
           
  
      <tr></tr>
  
      <tr></tr>
  
      <tr></tr>
  
      <tr></tr>
  
      <tr></tr>
  
      <tr></tr>
  
      <tr></tr>
  
      <tr></tr>
  
      <tr></tr>
  
      <tr></tr>
  
      <tr></tr>
  
      <tr>
  
      <td colSpan="11"></td>
  
      </tr>
  
      <tr>
  
          <td className="td-2" height="17" align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td className="td-3" align="left"></td>
  
      </tr>
  
      <tr>
  
          <td className="td-2" height="17" align="left"></td>
  
          <td align="left">Opis:</td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td className="td-3" align="left"></td>
  
      </tr>
  
      {data.uwagi2 ? (<>
  
      <tr>
  
          <td className="td-2" height="17" align="left"></td>
  
          <td colSpan="11"></td>
  
          <td className="td-3" align="left"></td>
  
      </tr>
  
      <tr>
  
          <td className="td-2" height="17" align="left"></td>
  
          <td colSpan="11"><div dangerouslySetInnerHTML={ { __html: data.uwagi2 } }></div></td>
  
          <td className="td-3" align="left"></td>
  
      </tr>
  
      <tr>
  
          <td className="td-2" height="17" align="left"></td>
  
          <td colSpan="11"></td>
  
          <td className="td-3" align="left"></td>
  
      </tr>
  
  
  
      </>) : null}
  
      
  
      <tr>
  
          <td className="td-2" height="17" align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td className="td-3" align="left"></td>
  
      </tr>
  
      <tr>
  
          <td className="td-2" height="17" align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td className="td-3" align="left"></td>
  
      </tr>
  
      <tr>
  
          <td className="td-2" height="17" align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td className="td-3" align="left"></td>
  
      </tr>
  
      <tr>
  
          <td className="td-2" height="17" align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td align="left"></td>
  
          <td className="td-3" align="left"></td>
  
      </tr>
      <tr>
  
          <td className="td-2"></td>
  
          <td  colSpan="2" height="17" align="center"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaTopLewo } }></div></td>
  
          <td align="left" ><font face="Verdana" size="1"><br></br></font></td>
  
          <td align="center" ><i><font face="Verdana" size="1"><br></br></font></i></td>
          <td align="center" ><i><font face="Verdana" size="1"><br></br></font></i></td>
  
          <td align="center" ><i><font face="Verdana" size="1"><br></br></font></i></td>
  
          <td align="center" colSpan="3"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaTopSrodek } }></div></td>
  
          <td className="td-3" align="center"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaTopPrawo } }></div></td>
  
      </tr>
      <tr>
  
          <td className="td-2"></td>
          <td align="center" ><i><font face="Verdana" size="1"><br></br></font></i></td>
          <td align="left" ><font face="Verdana" size="1"><br></br></font></td>
          <td align="center" ><i><font face="Verdana" size="1"><br></br></font></i></td>
          <td align="center" ><i><font face="Verdana" size="1"><br></br></font></i></td>
          <td align="center" ><i><font face="Verdana" size="1"><br></br></font></i></td>
          <td align="center" ><i><font face="Verdana" size="1"><br></br></font></i></td>
          <td align="center"className="td-3" colspan="5" ><i><font face="Verdana" size="1"><br></br></font></i></td>
  
      </tr>
  
      <tr>
  
          <td className="td-2" height="17" align="center"></td>
  
          <td align="left" colSpan="2"><font face="Verdana">&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;</font></td>
  
          <td align="left"></td>
  
          <td align="center" colSpan="2"><font face="Verdana">&hellip;&hellip;&hellip;&hellip;&hellip;</font></td>
  
          <td align="left"></td>
  
          <td align="center" colSpan="3"><font face="Verdana">&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;</font></td>
  
          <td className="td-3"  align="center"><font face="Verdana">&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;..</font></td>
  
      </tr>
  
      <tr>
  
          <td className="td-2"></td>
  
          <td  colSpan="2" height="17" align="center"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaLewo } }></div></td>
  
          <td align="left" ><font face="Verdana" size="1"><br></br></font></td>
  
          <td align="left" colSpan="2"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaData } }></div></td>
  
          <td align="center" ><i><font face="Verdana" size="1"><br></br></font></i></td>
  
          <td align="center" colSpan="3"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaSrodek } }></div></td>
  
          <td className="td-3" align="center"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaPrawo } }></div></td>
  
      </tr>
  
      <tr>
  
          <td className="td-8" height="17" align="left"></td>
  
          <td className="td-7" align="left"></td>
  
          <td className="td-7" align="left"></td>
  
          <td className="td-7" align="left"></td>
  
          <td className="td-7" align="left"></td>
  
          <td className="td-7" align="left"></td>
  
          <td className="td-7" align="left"></td>
  
          <td className="td-7" align="left"></td>
  
          <td className="td-7" align="left"></td>
  
          <td className="td-7" align="left"></td>
  
          <td className="td-6" align="left"></td>
  
      </tr>
  
  </tbody>
  
  </table>  
  

</React.Fragment>
    );
  }
}

